export default __webpack_public_path__ + "static/zeplin-0e86f42d7349b6e45e577dbb5e7bd52c.png";